const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoketIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    height: 32,
    id: "screenshot-ead713f5-05d7-80ac-8007-ba5935f81dac",
    viewBox: "2005 1234 32 32",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81dac",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "render-22999-Layer_2",
    viewBox: "0 0 26.77 26.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "render-22999-Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.32,26.4c5.31-1.2,7.29-4.27,7.29-4.27l-1.62-1.41-1.41-1.62s-3.24,2.16-4.27,7.29h0s0,0,0,0h0s0,0,0,0Z",
    style: {
      fill: "none",
      stroke: "#794c8a",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.6 17.79 15.88 20.63 8.21 25.32 11.39 20.28",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8.93 11.12 6.09 10.84 1.4 18.51 6.17 15.82",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65,21.66c3.84-1.82,8.69-4.56,12.18-8.05,2.63-2.63,4.09-5.3,4.89-7.56-1.13-.45-2.17-1.11-3.06-2s-1.55-1.93-2-3.06c-2.26.8-4.92,2.26-7.56,4.89-3.49,3.49-6.23,8.34-8.05,12.18.45.72.98,1.39,1.59,2s1.28,1.14,2,1.59Z",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.84,5.86c1.2-3.38.89-5.83.89-5.83,0,0-2.45-.31-5.83.89.44,1.1,1.08,2.12,1.95,2.99s1.88,1.52,2.99,1.95Z",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91,20.81c.52.52,1.09.96,1.71,1.33.33-.15.67-.31,1.02-.48-.72-.45-1.39-.98-2-1.59s-1.14-1.28-1.59-2c-.17.35-.33.69-.48,1.02.37.62.81,1.19,1.33,1.71Z",
    style: {
      fill: "none",
      stroke: "#794c8a",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.17,
    cy: 8.54,
    r: 2.17,
    style: {
      stroke: "#794c8a",
      strokeMiterlimit: 10,
      strokeWidth: ".5px",
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "render-22999-Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.32,26.4c5.31-1.2,7.29-4.27,7.29-4.27l-1.62-1.41-1.41-1.62s-3.24,2.16-4.27,7.29h0s0,0,0,0h0s0,0,0,0Z",
    style: {
      fill: "none",
      stroke: "#794c8a",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.6 17.79 15.88 20.63 8.21 25.32 11.39 20.28",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8.93 11.12 6.09 10.84 1.4 18.51 6.17 15.82",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65,21.66c3.84-1.82,8.69-4.56,12.18-8.05,2.63-2.63,4.09-5.3,4.89-7.56-1.13-.45-2.17-1.11-3.06-2s-1.55-1.93-2-3.06c-2.26.8-4.92,2.26-7.56,4.89-3.49,3.49-6.23,8.34-8.05,12.18.45.72.98,1.39,1.59,2s1.28,1.14,2,1.59Z",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.84,5.86c1.2-3.38.89-5.83.89-5.83,0,0-2.45-.31-5.83.89.44,1.1,1.08,2.12,1.95,2.99s1.88,1.52,2.99,1.95Z",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91,20.81c.52.52,1.09.96,1.71,1.33.33-.15.67-.31,1.02-.48-.72-.45-1.39-.98-2-1.59s-1.14-1.28-1.59-2c-.17.35-.33.69-.48,1.02.37.62.81,1.19,1.33,1.71Z",
    style: {
      fill: "none",
      stroke: "#794c8a",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.17,
    cy: 8.54,
    r: 2.17,
    style: {
      stroke: "#794c8a",
      strokeMiterlimit: 10,
      strokeWidth: ".5px",
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81dad",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81dad"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 2005,
    y: 1234.00715156127,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 32,
    height: 31.992848438730107,
    fill: "none",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81dae"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81daf",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81db0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81db0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2005.382568359375,1265.6044921875C2011.7298583984375,1264.16845703125,2014.0968017578125,1260.494140625,2014.0968017578125,1260.494140625L2012.1602783203125,1258.806640625L2010.474853515625,1256.86767578125C2010.474853515625,1256.86767578125,2006.6019287109375,1259.453125,2005.37060546875,1265.5927734375L2005.37060546875,1265.5927734375C2005.37060546875,1265.5927734375,2005.37060546875,1265.5927734375,2005.37060546875,1265.5927734375L2005.37060546875,1265.5927734375C2005.37060546875,1265.5927734375,2005.37060546875,1265.5927734375,2005.37060546875,1265.5927734375Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-1fc2f5ba-be2b-80ba-8007-c34df1076ca8-ead713f5-05d7-80ac-8007-ba5935f81db0",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2005.382568359375,1265.6044921875C2011.7298583984375,1264.16845703125,2014.0968017578125,1260.494140625,2014.0968017578125,1260.494140625L2012.1602783203125,1258.806640625L2010.474853515625,1256.86767578125C2010.474853515625,1256.86767578125,2006.6019287109375,1259.453125,2005.37060546875,1265.5927734375L2005.37060546875,1265.5927734375C2005.37060546875,1265.5927734375,2005.37060546875,1265.5927734375,2005.37060546875,1265.5927734375L2005.37060546875,1265.5927734375C2005.37060546875,1265.5927734375,2005.37060546875,1265.5927734375,2005.37060546875,1265.5927734375Z",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 0.5,
      stroke: "#794c8a",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81db1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81db1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2023.64794921875,1255.2998046875L2023.9822998046875,1258.69873046875L2014.81396484375,1264.3125L2018.6151123046875,1258.2802734375",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81db2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81db2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2015.674560546875,1247.31640625L2012.2799072265625,1246.9814453125L2006.6734619140625,1256.1611328125L2012.3753662109375,1252.94189453125",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81db3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81db3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2015.3399658203125,1259.931640625C2019.93017578125,1257.75341796875,2025.727783203125,1254.4736328125,2029.899658203125,1250.296875C2033.0433349609375,1247.14892578125,2034.78857421875,1243.953125,2035.744873046875,1241.248046875C2034.394287109375,1240.7099609375,2033.1510009765625,1239.919921875,2032.0870361328125,1238.8544921875C2031.023193359375,1237.7890625,2030.234375,1236.544921875,2029.6962890625,1235.19189453125C2026.9947509765625,1236.1494140625,2023.8150634765625,1237.89697265625,2020.659423828125,1241.044921875C2016.4876708984375,1245.2216796875,2013.21240234375,1251.02685546875,2011.03662109375,1255.623046875C2011.5745849609375,1256.484375,2012.2081298828125,1257.2861328125,2012.937255859375,1258.0166015625C2013.66650390625,1258.74658203125,2014.46728515625,1259.380859375,2015.327880859375,1259.91943359375Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81db4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81db4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2035.888427734375,1241.02099609375C2037.32275390625,1236.9755859375,2036.9521484375,1234.04296875,2036.9521484375,1234.04296875C2036.9521484375,1234.04296875,2034.023681640625,1233.671875,2029.983154296875,1235.1083984375C2030.50927734375,1236.4248046875,2031.274169921875,1237.6455078125,2032.3143310546875,1238.6865234375C2033.3541259765625,1239.728515625,2034.5614013671875,1240.505859375,2035.888427734375,1241.02099609375Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81db5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81db5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2012.0645751953125,1258.9140625C2012.6861572265625,1259.537109375,2013.3675537109375,1260.0634765625,2014.10888671875,1260.505859375C2014.503173828125,1260.32666015625,2014.90966796875,1260.13525390625,2015.327880859375,1259.931640625C2014.46728515625,1259.39306640625,2013.66650390625,1258.7587890625,2012.937255859375,1258.0283203125C2012.2081298828125,1257.29833984375,2011.5745849609375,1256.49658203125,2011.03662109375,1255.634765625C2010.8333740234375,1256.0537109375,2010.6422119140625,1256.4609375,2010.462890625,1256.85546875C2010.9051513671875,1257.59765625,2011.430908203125,1258.2802734375,2012.0526123046875,1258.90234375Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-1fc2f5ba-be2b-80ba-8007-c34df1079b8c-ead713f5-05d7-80ac-8007-ba5935f81db5",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2012.0645751953125,1258.9140625C2012.6861572265625,1259.537109375,2013.3675537109375,1260.0634765625,2014.10888671875,1260.505859375C2014.503173828125,1260.32666015625,2014.90966796875,1260.13525390625,2015.327880859375,1259.931640625C2014.46728515625,1259.39306640625,2013.66650390625,1258.7587890625,2012.937255859375,1258.0283203125C2012.2081298828125,1257.29833984375,2011.5745849609375,1256.49658203125,2011.03662109375,1255.634765625C2010.8333740234375,1256.0537109375,2010.6422119140625,1256.4609375,2010.462890625,1256.85546875C2010.9051513671875,1257.59765625,2011.430908203125,1258.2802734375,2012.0526123046875,1258.90234375Z",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 0.5,
      stroke: "#794c8a",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81db6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81db6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2026.7198356369072,
    cy: 1244.2285853684812,
    rx: 2.5939484497572494,
    ry: 2.597249573963836,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      strokeMiterlimit: 10,
      fill: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeMiterlimit: 10
    },
    id: "strokes-1fc2f5ba-be2b-80ba-8007-c34df1079b8d-ead713f5-05d7-80ac-8007-ba5935f81db6",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2026.7198356369072,
    cy: 1244.2285853684812,
    rx: 2.5939484497572494,
    ry: 2.597249573963836,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 0.5,
      stroke: "#794c8a",
      strokeOpacity: 1
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoketIcon);
export default __webpack_public_path__ + "static/media/roketIcon.716e57f00f1b3a818493f98f34bd5fef.svg";
export { ForwardRef as ReactComponent };